import { useState } from 'react';
import { useDebounceCallback } from 'usehooks-ts';

import { TextField } from './TextField';

type Props = {
  onDebouncedChange: (value: string) => void;
} & React.ComponentPropsWithoutRef<typeof TextField>;

export function DebouncedTextField({
  value,
  defaultValue,
  onDebouncedChange,
  ...props
}: Props): React.ReactElement {
  const debouncedChange = useDebounceCallback(onDebouncedChange, 500);
  const [internalValue, setInternalValue] = useState(value || '');

  const handleChange = (newValue: string) => {
    setInternalValue(newValue);
    debouncedChange(newValue);
  };

  return (
    <TextField
      {...props}
      value={internalValue}
      defaultValue={defaultValue}
      onChange={({ target }) => handleChange(target.value)}
    />
  );
}
